/**
 * Valida se o arquivo é válido
 * @param {File} file - Arquivo para validar
 * @param {Object} options - Opções de validação
 * @returns {Boolean}
 */
export function validFile(file, options = {}) {
  if (!file || !(file instanceof File)) {
    return false;
  }

  const {
    maxSize = 10 * 1024 * 1024, // 10MB padrão
    allowedTypes = [
      'application/pdf',
      'image/jpeg',
      'image/jpg',
      'image/png',
      'image/gif'
    ]
  } = options;

  // Valida tipo
  if (allowedTypes.length > 0 && !allowedTypes.includes(file.type)) {
    console.warn(`Tipo de arquivo não permitido: ${file.type}`);
    return false;
  }

  // Valida tamanho
  if (file.size > maxSize) {
    console.warn(`Arquivo muito grande: ${file.size} bytes (máximo: ${maxSize} bytes)`);
    return false;
  }

  return true;
}
